export default __webpack_public_path__ + "assets/ec8d15e1085d25445aee2e59de3a2441.svg";